<template>
  <div>
    <div
      v-for="(row, rowIndex) in rows"
      :key="rowIndex"
      class="items-container"
    >
      <div v-for="(item, index) in row" :key="index" class="item-container">
        <div
          class="item"
          :class="{ 'active-class': activeType === item.type }"
          @click="$emit('typeChanged', item.type)"
          :data-qa="`grid-item-${item.type}`"
        >
          <el-badge :value="$t('Campaign_Dialog_Beta')" :hidden="!item.beta">
            <icon class="icon" :glyph="item.icon" size="45" />
          </el-badge>
          <h3>{{ $t(item.title) }}</h3>
          <p class="item-description">
            {{ $t(item.description) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chunk } from 'lodash'

export default {
  name: 'Grid',

  props: {
    items: {
      type: Array,
      required: true
    },
    activeType: {
      type: String
    }
  },

  computed: {
    rows() {
      if (!this.items || !this.items.length) return []

      if (this.items.length <= 4) return chunk(this.items, 4)
      if (this.items.length % 4 === 0 || this.items.length % 7 === 0) {
        return chunk(this.items, 4)
      }
      if (this.items.length % 3 === 0 || this.items.length % 5 === 0) {
        return chunk(this.items, 3)
      }

      return [this.items]
    }
  }
}
</script>

<style scoped>
.active-class {
  background-color: #f2f5f9;
  outline: 3px solid #1d87c8;
  border-radius: 4px;
  box-sizing: border-box;
  margin: -1px;
  width: 256px !important;
  height: 252px !important;
}

.items-container {
  padding: 0 28px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.items-container > .item-container:not(:first-child) {
  margin-left: 20px;
}

.item-container {
  outline: 1px solid #a7acba;
  border-radius: 4px;
  box-sizing: border-box;
  transition: all 0.5s;
  margin-bottom: 20px;
}

.item-container:hover {
  box-shadow: rgba(67, 90, 111, 0.3) 0 0 1px,
    rgba(67, 90, 111, 0.47) 0 8px 10px -4px;
  transform: translateY(-2px);
  cursor: pointer;
}

.item {
  width: 254px;
  height: 250px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.icon {
  color: #1d87c8;
  margin-bottom: 35px;
}

.item-description {
  padding: 10px;
  word-break: break-word;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/common/components/layout/Grid.vue